<template>
  <navbar btn-background="bg-gradient-success" />
  <div class="page-header align-items-start min-vh-100 bg-sign-cover">
    <span class="mask bg-gradient-dark opacity-6"></span>
    <div class="container my-auto">
      <div class="row">
        <div class="col-lg-4 col-md-8 col-12 mx-auto">
          <div class="card z-index-0 fadeIn3 fadeInBottom">
            <div class="card-header p-0 position-relative mx-3 z-index-2">
              <div class="d-flex justify-content-center pt-3">
                <img :src="logo" class="sign-logo" />
              </div>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <material-input id="username" v-model="user" type="text" :label="t('heads.usr')" name="username" />
              </div>
              <div class="mb-3">
                <material-input id="password" v-model="pwd" type="password" :label="t('heads.pwd')" name="password" />
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <material-switch id="rememberMe" v-model="data.remem" name="Remember Me">
                  {{ $t("heads.rem") }}
                </material-switch>
                <a style="margin-top: -4px; text-decoration: none; color: #43a047" @click="forgetPassword">
                  {{ t("heads.fgpwd") }}
                </a>
              </div>
              <div class="text-center">
                <material-button class="my-4 mb-2" variant="gradient" color="success" size="lg" full-width
                  @click="login">
                  {{ $t("heads.log") }}
                </material-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer position-absolute bottom-2 py-2 w-100">
      <div class="container">
        <div class="row align-items-center justify-content-lg-between">
          <div class="col-12 my-auto text-center">
            <div class="copyright text-center text-sm text-white">
              © {{ new Date().getFullYear() }} {{ $t('apps.name') }} {{ $t('apps.version') }} 2.32
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { reactive, onBeforeMount, onBeforeUnmount, ref, inject } from "vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"
import { useI18n } from "vue-i18n"
import { JSEncrypt } from 'jsencrypt';

import Navbar from "@/examples/PageLayout/Navbar.vue"
import MaterialInput from "@/components/MaterialInput.vue"
import MaterialSwitch from "@/components/MaterialSwitch.vue"
import MaterialButton from "@/components/MaterialButton.vue"

import logo from "@/assets/img/pawn/logo_new1.png"
import { useUserSecurityStore } from "@/stores/usersecurity";
import { useLoaderStore } from "@/stores/loader";



const { t } = useI18n()
const swal = inject("$swal");

const store = useStore()
const userSStore = useUserSecurityStore();



const data = reactive({
  user: "",
  pwds: "",
  remem: false,
});

const user = ref("");
const pwd = ref("");

// const user = ref("nwuser01@nvtx.tech");
// const pwd = ref("P@ssw0rd");

// const user = ref("uat5user01@ibuddy.biz");
// const pwd = ref("UATP@ssw0rd");

// const user = ref("suchin.p");
// const pwd = ref("BKTP@ssw0rd");


const public_key = ref('');
const encryptedData = ref('');

const router = useRouter()


const clearData = () => {
  // console.log("Clear Data");
  userSStore.clearSession();
  const loaderStore = useLoaderStore();
  loaderStore.isLoading = false;
  loaderStore.activeRequests = 0;
  loaderStore.stopLoading();
  user.value = '';
  pwd.value = '';
  public_key.value = '';
  encryptedData.value = '';
};

clearData();

async function login() {
  if (user.value.trim() === '' || pwd.value.trim() === '') {
    swal("กรุณากรอก Username & Password", "", "error");
  } else {
    const loaderStore = useLoaderStore();
    loaderStore.startLoading();
    // console.log("Request started public");
    getpublicKey()
  }
}

function forgetPassword() {
  router.push({ name: "ForgetPassword" });
}

function getpublicKey() {
  userSStore.public().then((resdata) => {
    public_key.value = resdata.key
    getnonce(resdata)
  }).catch((err) => {
    const loaderStore = useLoaderStore();
    loaderStore.stopLoading();
    // console.log("Request failed public");
    let msg = ''
    if (err.response) {
      if (err.response.status === 408) {
        console.log("Authentication session is timeout. Please try again"); // Please change to alert or notify box.
        console.error("", err);
        msg = 'Authentication session is timeout. Please try again'
      } else if (err.response.status === 401) {
        console.log("Your credential is invalid. Please try again"); // Please change to alert or notify box.
        msg = 'Your credential is invalid. Please try again'
      } else {
        console.error("", err);
        console.log("Authentication Failed. Please try again" + JSON.stringify(err.response)); // Please change to alert or notify box.
        msg = 'Authentication Failed. Please try again'
      }

    } else {
      msg = 'Unexpected Error. Please reload and try again'
      console.log("Unexpected Error. Please reload and try again"); // Please change to alert or notify box.
    }
    swal("เข้าสู่ระบบไม่สำเร็จ", msg, "error");
  });
}

function getnonce(data) {
  userSStore.nonce(data.key).then((resdata) => {
    getlogin_url(resdata)
  }).catch((err) => {
    const loaderStore = useLoaderStore();
    loaderStore.stopLoading();
    // console.log("Request failed nonce");
    let msg = ''
    if (err.response) {
      if (err.response.status === 408) {
        console.log("Authentication session is timeout. Please try again"); // Please change to alert or notify box.
        console.error("", err);
        msg = 'Authentication session is timeout. Please try again'
      } else if (err.response.status === 401) {
        console.log("Your credential is invalid. Please try again"); // Please change to alert or notify box.
        msg = 'Your credential is invalid. Please try again'
      } else {
        console.error("", err);
        console.log("Authentication Failed. Please try again" + JSON.stringify(err.response)); // Please change to alert or notify box.
        msg = 'Authentication Failed. Please try again'
      }

    } else {
      msg = 'Unexpected Error. Please reload and try again'
      console.log("Unexpected Error. Please reload and try again"); // Please change to alert or notify box.
    }
    swal("เข้าสู่ระบบไม่สำเร็จ", msg, "error");
  });
}




async function encrypt(text) {
  encryptedData.value = ''
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(public_key.value);
  let encrypted = encrypt.encrypt(text);
  return encrypted.toString();
}

async function getlogin_url(data) {
  const hmacDigest = data.nonce + '|:|' + data.aud + '|:|' + pwd.value.trim();
  encryptedData.value = await encrypt(hmacDigest)
  if (encryptedData.value !== '') {
    let data1 = "";
    data1 = {
      encrypttext: encryptedData.value,
      user: user.value.trim(),
    }
    const payload = data1;
    userSStore.login_url(payload).then((logindata) => {
      const loaderStore = useLoaderStore();
      loaderStore.stopLoading();
      // console.log("Request finished login");
      localStorage.removeItem("userName");
      localStorage.removeItem("imageL");
      if (logindata.token) {
        userSStore.authorize(true).then((authData) => {
          // console.log("authData x : ", JSON.stringify(authData));
          if (authData.accessToken) {
            // เคลียร์ข้อมูลตั๋วที่หมดอายุก่อนย้ายหน้า
            clearExpiredPrintDataOnLogin(); 
            localStorage.setItem("userName", user.value.trim());
            console.log("You are login success");
            router.push({ name: "Dashboard" });
          } else {
            console.log("You are not allow to access the site. Please contact admin."); // Please change to alert or notify box.
            swal("เข้าสู่ระบบไม่สำเร็จ", "You are not allow to access the site. Please contact admin", "error");
          }
          // appStore.unloading();
        });
      } else {
        console.log("Authentication Failed. Please try again.");
        swal("เข้าสู่ระบบไม่สำเร็จ", "Authentication Failed. Please try again", "error");
        // appStore.unloading();
      }
    }).catch((err) => {
      const loaderStore = useLoaderStore();
      loaderStore.stopLoading();
      // console.log("Request failed login");
      let msg = ''
      if (err.response) {
        if (err.response.status === 408) {
          console.log("Authentication session is timeout. Please try again"); // Please change to alert or notify box.
          console.error("", err);
          msg = 'Authentication session is timeout. Please try again'
        } else if (err.response.status === 401) {
          console.log("Your credential is invalid. Please try again"); // Please change to alert or notify box.
          msg = 'Your credential is invalid. Please try again'
        } else {
          console.error("", err);
          console.log("Authentication Failed. Please try again." + JSON.stringify(err.response)); // Please change to alert or notify box.
          msg = 'Authentication Failed. Please try again'
        }

      } else {
        msg = 'Unexpected Error. Please reload and try again'
        console.log("Unexpected Error. Please reload and try again."); // Please change to alert or notify box.
      }
      swal("เข้าสู่ระบบไม่สำเร็จ", msg, "error");
    });
  }
}

// ฟังก์ชันสำหรับเคลียร์ข้อมูล listprintTK ที่เกิน 7 วัน (สำหรับหน้า Login)
const clearExpiredPrintDataOnLogin = () => {
    // 1. ดึงข้อมูลจาก LocalStorage
    const rawData = JSON.parse(localStorage.getItem("listprintTK")) || [];
    
    if (rawData.length === 0) return; // ถ้าไม่มีข้อมูลอยู่แล้ว ให้ข้ามไปเลย

    const SEVEN_DAYS_IN_MS = 7 * 24 * 60 * 60 * 1000; // 7 วัน (มิลลิวินาที)
    const now = new Date();

    // 2. กรองเอาเฉพาะข้อมูลที่ยังไม่หมดอายุ (ไม่เกิน 7 วัน)
    const cleanedData = rawData.filter(item => {
        const itemDate = new Date(item.createDate);
        const timeDiff = now - itemDate;
        return timeDiff <= SEVEN_DAYS_IN_MS;
    });

    // 3. บันทึกข้อมูลที่สะอาดแล้วกลับลง LocalStorage
    localStorage.setItem("listprintTK", JSON.stringify(cleanedData));
};


function mapMutations() {
  store.commit("toggleEveryDisplay");
  store.commit("toggleHideConfig");
}
mapMutations();

function setDisplayLayouts(bool) {
  store.state.showConfig = bool;
  store.state.showNavbar = bool;
  store.state.showSidenav = bool;
  store.state.showFooter = bool;

}


onBeforeMount(() => {
  setDisplayLayouts(false);
  userSStore.clearSession();
});

onBeforeUnmount(() => {
  setDisplayLayouts(true);
});

</script>

<style lang="scss" scoped>
.bg-sign-cover {
  background-image: url('~@/assets/img/bg_signin.jpg');
}

.sign-logo {
  max-width: 140px;
  margin: 0 auto;
}


</style>
